<template>
  <transition name="overlay-fade">
    <div v-if="isOpen" class="wishlist-overlay" @click="isOpen = false"></div>
  </transition>

  <transition name="drawer-slide">
    <div v-if="isOpen" class="wishlist-drawer" role="dialog" aria-label="La tua lista">
      <div class="wishlist-drawer__header">
        <h3 class="wishlist-drawer__title">La tua lista</h3>
        <button class="wishlist-drawer__close" @click="isOpen = false" aria-label="Chiudi">&#x2715;</button>
      </div>

      <div class="wishlist-drawer__body">
        <p v-if="items.length === 0" class="wishlist-drawer__empty">
          Nessun prodotto aggiunto alla lista.
        </p>
        <ul v-else class="wishlist-list">
          <li v-for="item in items" :key="item.id" class="wishlist-item">
            <a :href="item.url" class="wishlist-item__link">
              <img :src="item.image" :alt="item.title" class="wishlist-item__img" />
              <div class="wishlist-item__info">
                <strong class="wishlist-item__title">{{ item.title }}</strong>
                <span class="wishlist-item__name">{{ item.name }}</span>
              </div>
            </a>
            <button class="wishlist-item__remove" @click="remove(item.id)" aria-label="Rimuovi">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M262.2 48C248.9 48 236.9 56.3 232.2 68.8L216 112L120 112C106.7 112 96 122.7 96 136C96 149.3 106.7 160 120 160L520 160C533.3 160 544 149.3 544 136C544 122.7 533.3 112 520 112L424 112L407.8 68.8C403.1 56.3 391.2 48 377.8 48L262.2 48zM128 208L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 208L464 208L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 208L128 208zM288 280C288 266.7 277.3 256 264 256C250.7 256 240 266.7 240 280L240 456C240 469.3 250.7 480 264 480C277.3 480 288 469.3 288 456L288 280zM400 280C400 266.7 389.3 256 376 256C362.7 256 352 266.7 352 280L352 456C352 469.3 362.7 480 376 480C389.3 480 400 469.3 400 456L400 280z"/></svg>
            </button>
          </li>
        </ul>
      </div>

      <div v-if="items.length > 0" class="wishlist-drawer__footer">
        <a :href="contactUrl" class="btn wishlist-drawer__cta">Richiedi informazioni</a>
        <button class="wishlist-drawer__clear" @click="clearAll">Svuota lista</button>
      </div>
    </div>
  </transition>
</template>

<script>
const STORAGE_KEY = 'ideaerre_wishlist';

export default {
  name: 'WishlistApp',
  props: {
    contactUrl: { type: String, default: '#' },
  },
  data() {
    return { items: [], isOpen: false };
  },
  mounted() {
    this.load();
    window.addEventListener('wishlist:updated', this.load);

    const heart = document.querySelector('.heart');
    if (heart) heart.addEventListener('click', this.toggle);
  },
  beforeUnmount() {
    window.removeEventListener('wishlist:updated', this.load);
    const heart = document.querySelector('.heart');
    if (heart) heart.removeEventListener('click', this.toggle);
  },
  methods: {
    load() {
      this.items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      this.updateHeartState();
    },
    updateHeartState() {
      const heartSvg = document.querySelector('.heart svg');
      if (!heartSvg) return;
      heartSvg.classList.toggle('added', this.items.length > 0);
    },
    toggle(e) {
      e.preventDefault();
      this.isOpen = !this.isOpen;
    },
    remove(id) {
      this.items = this.items.filter(p => p.id !== id);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.items));
      window.dispatchEvent(new CustomEvent('wishlist:updated'));
    },
    clearAll() {
      this.items = [];
      localStorage.removeItem(STORAGE_KEY);
      window.dispatchEvent(new CustomEvent('wishlist:updated'));
    },
  },
};
</script>
